import { HeaderService } from '../../../verticals/src/services/Header.service';

export const useScrollToElement = (elementId, excludeElements = []) => {
    const element = elementId ? document.querySelector(elementId) : false;
    if (!element) {
        return;
    }

    const headerAndStatusBarOffset = HeaderService.getHeaderAndStatusBarHeight();
    let sortingButtonsOffset = 0;
    excludeElements.forEach(el => {
        sortingButtonsOffset += document.querySelector(el).offsetHeight;
    });
    const elementPosition = element.getBoundingClientRect().top;
    const offsetPosition =
        elementPosition + window.scrollY - ( headerAndStatusBarOffset + sortingButtonsOffset );

    window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
    });
};
